var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretUpRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0155 7.76512C9.98069 7.79999 9.93934 7.82765 9.89381 7.84652C9.84829 7.86539 9.79949 7.8751 9.75021 7.8751C9.70093 7.8751 9.65213 7.86539 9.60661 7.84652C9.56108 7.82765 9.51972 7.79999 9.4849 7.76512L6.00021 4.27996L2.51552 7.76512C2.44516 7.83548 2.34972 7.87502 2.25021 7.87502C2.1507 7.87502 2.05526 7.83548 1.9849 7.76512C1.91453 7.69475 1.875 7.59932 1.875 7.49981C1.875 7.4003 1.91453 7.30486 1.9849 7.23449L5.7349 3.48449C5.76972 3.44963 5.81108 3.42197 5.85661 3.4031C5.90213 3.38423 5.95093 3.37451 6.00021 3.37451C6.04949 3.37451 6.09829 3.38423 6.14381 3.4031C6.18934 3.42197 6.23069 3.44963 6.26552 3.48449L10.0155 7.23449C10.0504 7.26932 10.078 7.31068 10.0969 7.3562C10.1158 7.40173 10.1255 7.45053 10.1255 7.49981C10.1255 7.54909 10.1158 7.59789 10.0969 7.64341C10.078 7.68893 10.0504 7.73029 10.0155 7.76512Z",
    fill: "#C7061F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUpRed);
export default __webpack_public_path__ + "static/media/CaretUpRed.e068aadfe0dc955c37f3e0adb738f390.svg";
export { ForwardRef as ReactComponent };